


















































import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import AbpBase from '../../../lib/abpbase'
import {Loading} from 'element-ui';
import myTable from '../../../components/table/my-table.vue'
import Query from '../../../components/query/queryHeard.vue'
import {QueryUnit, CreateUnit, EditUnit, QuerySupplier, QueryManufacturer} from '../../../api/basicDictionary'
import {QueryTenant} from '../../../api/shipmentsManagement'
import myform from '../../../components/form/index.vue'
import {GetMachineList, GetMachineTypeList, InsertMachine, UpdateMachine} from "@/api/machines"

@Component({
    components: {myTable, myform, Query}
})
export default class extends AbpBase {
    model: any = {
        MachineName: '',
        Source: null,
        TenantId: null,
        MachineNo: '',
        Manufacturer: ''
    }
    list: Array<object> = []
    formShow: boolean = false
    formTitle: string = ''
    formData: object = {}
    formItem: Array<object> = []
    tenants: any[] = []
    manufacturers: any[] = []
    types: any[] = []
    units: any[] = []
    sources: any[] = [
        {value: 1, text: '集团'},
        {value: 2, text: '中心'},
    ]

    conditions: any = []

    //获取条件下拉框
    async getSelects() {
        this.getUnits()
        this.tenants = ((await QueryTenant({queryString: '', pageSize: 10000, page: 1})).data).map((item: any) => {
            return {
                value: item.tenantId,
                text: item.name,
            }
        })
        this.manufacturers = ((await QueryManufacturer({
            queryString: '',
            pageSize: 10000,
            page: 1
        })).data.items).map((item: any) => {
            return {
                value: item.name,
                text: item.name,
            }
        })
        this.types = ((await GetMachineTypeList({
            status: true,
            page: 1,
            pageSize: 10000
        })).items).map((item: any) => {
            return {
                value: item.id,
                text: item.machineTypeName,
            }
        })
        this.conditions = [
            {
                name: 'MachineName',
                dataType: 1,
                value: this.model.MachineName,
                label: '设备名称',
            },
            {
                name: 'TenantId',
                dataType: 6,
                value: this.model.TenantId,
                label: '中心',
                options: this.tenants
            },
            {
                name: 'Manufacturer',
                dataType: 1,
                value: this.model.Manufacturer,
                label: '生产厂家',
            },
            {
                name: 'Source',
                dataType: 6,
                value: this.model.Source,
                label: '来源',
                options: this.sources
            },
            {
                name: 'MachineNo',
                dataType: 1,
                value: this.model.MachineNo,
                label: '设备编号',
            },
        ]
    }

    uploadLoading = false
    loadingText = '上传中...'

    //导入。
    uploadExeclProgress(e) {
        this.uploadLoading = true
        this.loadingText = '上传进度' + Math.floor(e.percent) + '%'
    }

    beforeUploadExecl() {

    }

    uploadExecl() {
        this.$message.success('上传成功')
        this.uploadLoading = false
        this.getData()
    }

    uploadExeclError() {
        this.$message.error('上传出错')
        this.uploadLoading = false
    }

    async created() {
        await this.getSelects()
        this.getData()
    }

    async getUnits() {
        this.units = ((await QueryUnit({
            queryString: '',
            pageSize: 10000,
            page: 1
        })).data.items).map((item: any) => {
            return {
                value: item.name,
                text: item.name,
            }
        })
    }

    async getData() {
        this.table.loading = true
        let search = {}
        this.conditions.forEach((item: any) => {
            if (item.value)
                search[item.name] = item.value
        })
        let data = {...search, ...this.table}
        let res = await GetMachineList(data)
        this.table.totalCount = res.totalCount;
        this.list = res.items;
        // this.list = res
        this.table.loading = false
    }

    pageChange(page: number) {
        this.table.page = page
        this.getData();
    }

    pagesizeChange(pagesize: number) {
        this.table.pageSize = pagesize
        this.getData();
    }

    async addOrEdit(row: object) {
        this.formTitle = !row ? '新增' : '编辑'
        this.formData = {
            machineNo: '',
            machineTypeId: '',
            machineName: '',
            manufacturer: '',
            machineModel: '',
            tenantId: '',
            price: '',
            unit: '',
            source: '',
            status: true,
        }
        this.formData = Object.assign(this.formData, row)
        this.formItem = [
            {
                column: 12,
                show: true,
                label: '编号',
                name: 'machineNo',
                type: 'text',
                placeholder: '请输入编号',
                rules: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                ]
            },
            {
                column: 12,
                show: true,
                label: '设备类型',
                name: 'machineTypeId',
                type: 'select',
                placeholder: '请选择生产厂家',
                rules: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                ],
                options: this.types
            },
            {
                column: 12,
                show: true,
                label: '名称',
                name: 'machineName',
                type: 'text',
                placeholder: '请输入名称',
                rules: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                ]
            },
            {
                column: 12,
                show: true,
                label: '型号',
                name: 'machineModel',
                type: 'text',
                placeholder: '请输入型号',
                rules: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                ]
            },
            {
                column: 12,
                show: true,
                label: '生产厂家',
                name: 'manufacturer',
                type: 'select',
                placeholder: '请选择生产厂家',
                rules: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                ],
                options: this.manufacturers
            },
            {
                column: 12,
                show: true,
                label: '中心',
                name: 'tenantId',
                type: 'select',
                placeholder: '请选择中心',
                rules: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                ],
                options: this.tenants
            },
            {
                column: 12,
                show: true,
                label: '单位',
                name: 'unit',
                type: 'select',
                placeholder: '请选择单位',
                rules: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                ],
                options: this.units
            },
            {
                column: 12,
                show: true,
                label: '金额',
                name: 'price',
                type: 'number',
                placeholder: '请输入金额',
                rules: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                ]
            },
            {
                column: 12,
                show: true,
                label: '来源',
                name: 'source',
                type: 'select',
                placeholder: '请选择来源',
                rules: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                ],
                options: this.sources
            },
            {
                column: 12,
                show: true,
                label: '状态',
                name: 'status',
                type: 'select',
                placeholder: '请选择状态',
                rules: [
                    {required: true, message: '不能为空', trigger: 'blur'},
                ],
                options: [
                    {value: true, text: '正常'},
                    {value: false, text: '报废'},
                ]
            },
        ]
        this.formShow = true
    }

    async submit(data: any) {
        let res;
        data.dialysisCenter = data.tenantId
        if (data.id) {
            res = await UpdateMachine(data)
        } else {
            res = await InsertMachine(data)
        }
        if (res.code === 2000) {
            this.formShow = false
            this.getData()
        }
    }

    columns: Array<object> = [
        {title: '编号', key: 'machineNo'},
        {title: '设备类型', key: 'machineTypeName'},
        {title: '中心', key: 'tenantId'},
        {title: '名称', key: 'machineName'},
        {title: '型号', key: 'machineModel'},
        {title: '厂家', key: 'manufacturer'},
        {title: '单位', key: 'unit'},
        {
            title: '登记日期',
            key: 'creationTime',
            render: (h: any, p: any) => {
                return h('span', new Date(p.row.creationTime).toLocaleDateString())
            }
        },
        {
            title: '来源',
            key: 'source',
            render: (h: any, p: any) => {
                return h('span', p.row.source === 1 ? '集团' : '中心')
            }
        },

        {
            title: '状态',
            key: 'wubi',
            render: (h: any, p: any) => {
                return h('el-tag', {
                    props: {
                        type: p.row.status ? 'success' : 'danger',
                    },
                }, p.row.status ? "正常" : "报废")
            }
        },
        {
            title: '操作',
            width: '80',
            render: (h: any, p: any) => {
                return h('el-button', {
                    props: {
                        type: 'text',
                        size: 'small'
                    },
                    on: {
                        click: () => {
                            this.addOrEdit(p.row)
                        }
                    }
                }, '编辑')
            }
        },
    ]
}
